import { Text, Token } from '@revolut-internal/ui-kit'
import styled from 'styled-components'

export const TextMessageMarkdownWrapper = styled(Text)`
  white-space: pre-wrap;

  p {
    margin: 0;
  }

  ul,
  ol,
  li {
    line-height: normal;
    margin: 0 0 0 ${Token.space.s16};
    padding: 0;
  }

  ul {
    list-style: disc;
  }

  ol {
    list-style: numeric;
  }

  hr {
    border: none;
    background-color: ${Token.color.greyTone5};
    height: 1px;
  }
`
